module.exports = __webpack_public_path__ + "img/fastTrackCadetTraining.795796fa.jpg";